import { UserService } from '../user/services/user.service';

import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
} from '@angular/forms';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export class UsernameValidator {
  static usernameValidator(userService: UserService): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return userService.userAlreadyExists(control.value).pipe(
        map(data => {
          return data ? { usernameExists: true } : null;
        }),
        catchError((e: Response) => {
          console.log('getUserData Error', e);
          return throwError(new Error(`${e.status} ${e.statusText}`));
        })
      );
      /*
      return userService.userAlreadyExists(control.value).subscribe(

        (result: boolean) => result ? null : { invalidAsync: true},
        err => { invalidAsync: true}
        );

       */
    };
  }
}
